/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { CreateCourseRequestExternalProductId } from './createCourseRequestExternalProductId';
import type { CreateCourseRequestSegments } from './createCourseRequestSegments';

/**
 * create course request
 */
export interface CreateCourseRequest {
  title: string;
  description?: string;
  ects?: number;
  language?: string;
  externalProductId?: CreateCourseRequestExternalProductId;
  segments?: CreateCourseRequestSegments;
}
